import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { MenuStore } from '../../../menus/service/menu.store';
import { OnyxEvent } from '../../models/event';
import { EventStore } from '../../service/event.store';
import { ReservationCompareStore } from '../../service/reservation-compare-store';
import { AuthenticationStore } from '../../../permission/services/authentication.store';

@Component({
  selector: 'pioneer-rsvp',
  templateUrl: './rsvp-page.component.html'
})
export class RsvpComponent implements OnInit {

  public onyxEvent: OnyxEvent;

  disableCompareButton$: Observable<boolean>;
  showReservationCompareSummary$: Observable<boolean>;
  areRsvpsPresent$: Observable<boolean>;

  isInDetail: boolean;

  displayAddRsvp: boolean;

  constructor(
    private eventStore: EventStore,
    private reservationCompareStore: ReservationCompareStore,
    private menuStore: MenuStore,
    private router: Router,
    private authStore: AuthenticationStore
  ) { }

  ngOnInit(): void {
    this.eventStore.selectedEvent.subscribe(event => this.onyxEvent = event);
    if (this.onyxEvent) {
      this.menuStore.setPageHeader(this.onyxEvent.name, this.onyxEvent.eventProperty.subscriber);
    }

    this.disableCompareButton$ = this.reservationCompareStore.isRsvpCompareListEmpty();
    this.showReservationCompareSummary$ = this.reservationCompareStore.getShowReservationCompareSummary();
    this.areRsvpsPresent$ = this.reservationCompareStore.areRsvpsPresent();

    this.checkDetailPath(this.router.url);

    this.displayAddRsvp = this.authStore.hasPermission(['AddRsvp', 'UploadRsvp']);
  }

  navigateTo(path: string) {
    this.checkDetailPath(path);
    this.router.navigate([path]);
  }

  checkDetailPath(path: string) {
    this.isInDetail = path.indexOf('/detail') !== -1;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/rsvp/rsvp-page/rsvp-page.component.ts